module.exports = __webpack_public_path__ + "img/sld_star2_delta1_transformer_t1_b1.c5c4d136.svg";